import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { CRMFilaCaptacao } from "../../../models/crm/crmfila-captacao";
import { NotificacaoService } from "../../../services/notificacao.service";
import { GlobalService } from "../../../services/global.service";
import { CarregandoService } from "../../../services/carregando.service";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatPaginator,
  PageEvent,
} from "@angular/material";
import { PaginatorService } from "../../../services/paginator.service";
import { CRMOportunidade } from "../../../models/crm/crmoportunidade";
import { CrmoportunidadeService } from "../../../services/crm/crmoportunidade.service";
import { Filtro } from "../../../models/filtro";
import { Ibge } from "../../../models/ibge";
import { IbgeService } from "src/app/services/ibge.service";
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from "sweetalert2";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";

@Component({
  selector: "app-card-sem-usuario",
  templateUrl: "./card-sem-usuario.component.html",
  styleUrls: ["./card-sem-usuario.component.scss"],
})
export class CardSemUsuarioComponent implements OnInit {
  @ViewChild("paginator", { static: false }) paginator: MatPaginator;

  idFunil: number;
  lista: CRMFilaCaptacao[] = [];

  paginacao = { tamanhoMaximo: 5, total: 0, paginaAtual: 1 };
  campoOrdenacao: "uf";
  ordenarDesc = false;
  listaDeItensPorPagina = [];
  itensPorPagina = 10;

  filtroNome: Filtro = { Propriedade: "nome", Valor: "" };
  filtros: Filtro[] = [this.filtroNome];
  estados = [
    "AC",
    "AL",
    "AP",
    "AM",
    "BA",
    "CE",
    "DF",
    "ES",
    "GO",
    "MA",
    "MT",
    "MS",
    "MG",
    "PA",
    "PB",
    "PR",
    "PE",
    "PI",
    "RJ",
    "RN",
    "RS",
    "RO",
    "RR",
    "SC",
    "SP",
    "SE",
    "TO",
  ];
  estadoSelecionado = undefined;
  cidades: Ibge[] = [];
  cidadeSelecionada = undefined;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private notificacaoService: NotificacaoService,
    private globalService: GlobalService,
    private utilitarioService: UtilitarioService,
    private ibgeService: IbgeService,
    private crmoportunidadeService: CrmoportunidadeService,
    private carregandoService: CarregandoService,
    private paginatorService: PaginatorService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<CardSemUsuarioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.idFunil = Number(this.data.idFunil);
  }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.listarFilaCaptacao();
  }

  listarFilaCaptacao() {
    this.carregandoService.mostra("buscaFilaCaptacao");
    this.crmoportunidadeService
      .listarFilaDeCaptacao(
        this.paginacao.paginaAtual,
        this.itensPorPagina,
        this.campoOrdenacao,
        this.ordenarDesc ? "desc" : "asc",
        this.filtroNome.Valor,
        this.estadoSelecionado,
        this.cidadeSelecionada,
        this.idFunil
      )
      .subscribe(
        (dados) => {
          this.lista = dados.itens;

          if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
            this.itensPorPagina = 10;
          }

          this.paginacao.total = dados.total;

          this.carregandoService.esconde("buscaFilaCaptacao");
        },
        (erro) => {
          this.notificacaoService.erro(erro);
          this.carregandoService.esconde("buscaFilaCaptacao");
        }
      );
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize) {
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);
    }

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.listarFilaCaptacao();
  }

  buscarCidades(nomeCidade?: string) {
    this.carregandoService.mostra('buscaCidades');
    this.ibgeService.consultarPorEstado(this.estadoSelecionado).subscribe((ibges: Ibge[]) => {
      this.cidades = ibges;

      if (nomeCidade) {
        this.cidadeSelecionada = this.cidades.find(s => this.utilitarioService.remover_acentos_espaco(s.cidade.toLowerCase().trim()) === this.utilitarioService.remover_acentos_espaco(nomeCidade.toLowerCase().trim())) ?
          this.cidades.find(s => this.utilitarioService.remover_acentos_espaco(s.cidade.toLowerCase().trim()) === this.utilitarioService.remover_acentos_espaco(nomeCidade.toLowerCase().trim())).cod : undefined;
      }

      this.carregandoService.esconde('buscaCidades');
    }, (erro) => {
      this.carregandoService.esconde('buscaCidades');
    });
  }

  captar(op: CRMFilaCaptacao) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente capturar este integrador?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('capturaFilaCaptacao');
        this.crmoportunidadeService.captarOportunidade(op).subscribe(data => {
          this.carregandoService.esconde('capturaFilaCaptacao');
          this.notificacaoService.sucesso('Oportunidade capturada com sucesso!!!');
          this.fechar();
        }, (erro) => {
          this.carregandoService.esconde('capturaFilaCaptacao');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({
        length: this.paginator.length,
        pageIndex: this.paginator.pageIndex,
        pageSize: this.paginator.pageSize,
      });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === "string") {
      a = a.toLowerCase();
    }

    if (typeof b === "string") {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra(tipo: number = 0) {
    this.listarFilaCaptacao();
    this.paginator.firstPage();
  }

  fechar() {
    this.dialogRef.close();
  }
}
